import React from 'react';

import CheckInPresenter from '../../../../../../../../presenters/FastCash/CheckInPresenter';

const CheckIns = (props) => {
  const { checkIns } = props;

  return checkIns.map((checkIn) => (
    <div key={CheckInPresenter.id(checkIn)}>
      {CheckInPresenter.createdAtReadable(checkIn)}
    </div>
  ));
};

export default CheckIns;
